import { Button, Modal } from '@nike/eds'
import { type Dispatch, type SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { type Warning } from 'types'

interface WarningModalProps {
  warning: Warning | null
  setWarning: Dispatch<SetStateAction<Warning | null>>
}

export const WarningModal = ({ warning, setWarning }: WarningModalProps) => {
  const { t } = useTranslation()
  const closeModal = () => {
    if (warning?.onClose) {
      warning.onClose()
    }
    setWarning(null)
  }

  const headerSlot = (
    <div>
      <p className='text-5xl p-2'>{ warning?.title }</p>
    </div>
  )

  const footerSlot = (
    <div className='flex justify-end'>
      <Button className='text-xl' onClick={closeModal}>{t('buttons.continue')}</Button>
    </div>
  )

  return (
    <>
      <Modal
        isOpen={warning != null}
        onDismiss={closeModal}
        headerSlot={headerSlot}
        footerSlot={footerSlot}
        hideFade
      >
        <p className='text-3xl whitespace-pre-line'>{ warning?.message }</p>
      </Modal>
    </>
  )
}
